import React from "react";
import { useTranslation } from "react-i18next";

const PartnerLogos = ({ items = [], loading = false }) => {
  const { t } = useTranslation();
  const placeholders = Array.from({ length: 10 }, (_, i) => ({ id: `ph-${i}` }));
  const renderItems = (loading ? placeholders : items).slice(0, 10);

  return (
    <section className="bg-white w-full overflow-x-hidden" aria-label="Partner logos">

      {/* <div className="w-full border-t border-black/10 pb-6" /> */}
      <div className="mx-auto max-w-7xl px-4">
        <div
          className="
            grid items-center gap-x-8 gap-y-6
          "
          style={{
            gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
          }}
        >
          {renderItems.map((it) => (
            <div
              key={it.id}
              className="flex h-14 items-center justify-center"
              title={it.name}
            >
              {loading ? (
                <div
                  className="h-10 w-full max-w-[96px] animate-pulse rounded-sm bg-gray-200"
                  aria-hidden="true"
                />
              ) : it.logoUrl ? (
                <div className="h-14 w-auto max-w-[96px]">
                  <img
                    src={it.logoUrl}
                    alt={it.name ?? t("landing.partnerLogo")}
                    className="h-14 w-auto max-w-[96px] object-contain"
                    loading="lazy"
                  />
                </div>
              ) : (
                <div className="flex h-10 w-full max-w-[96px] items-center justify-center rounded-sm bg-black/5 px-2 text-xs font-semibold text-gray-500">
                  {it.name ?? t("landing.logo")}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerLogos;
